import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Analytics } from '@vercel/analytics/react';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';
import ScrollManager from './components/ScrollManager';
import { SchedulingProvider } from './context/SchedulingContext';

export function AppRoutes() {
  return (
    <>
      <SchedulingProvider>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/work" element={<Navigate replace to="/projects" />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </SchedulingProvider>
      <Analytics />
    </>
  );
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <AppRoutes />
      </Router>
    </MotionConfig>
  );
}

export default App;
